// tslint:disable-next-line:file-name-casing
export enum EHosts {
    WATABI = "WATABI",
    QUOTATION = "QUOTATION",
    OSMAN = "OSMAN",
    GALILEO = "GALILEO",
    TRANSAVIA = "TRANSAVIA",
    TRAVELPORT = "TRAVELPORT",
    TRAVELFUSION = "TRAVELFUSION",
    EXPEDIA = "EXPEDIA",
    JONVIEW = "JONVIEW",
    APITUDE = "APITUDE",
    BONOTEL = "BONOTEL",
    AMADEUS = "AMADEUS",
}

